module.exports = __webpack_public_path__ + "img/you@2x.ee2ada88.png";